import { Flex, Text } from '@components';
import { styled } from '@mui/material';

export const ContentContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  padding: theme.spacing(5, 17),
  paddingTop: theme.spacing(0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(16, 10),
  },
}));

export const RequiredTimeText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const RequiredTime = ({ minutes }: { minutes: number }) => (
  <RequiredTimeText variant='h5' fontWeight='fontWeightMedium'>
    ~ {minutes} min{minutes > 1 ? 's' : ''}
  </RequiredTimeText>
);
